import { render, staticRenderFns } from "./AaprobarPostgrado.vue?vue&type=template&id=32a037f4"
import script from "./AaprobarPostgrado.vue?vue&type=script&lang=js"
export * from "./AaprobarPostgrado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports